export function uppercase(val) {
  return val ? val.toLocaleUpperCase() : val
}

export function capitalize(val) {
  if (!val) return val
  return val
    .toLocaleLowerCase()
    .replace(/\b\w/g, (char) => char.toLocaleUpperCase())
}
